import type { IconSvgObject } from './types';

const SquaresExcludeIcon: IconSvgObject = [
  ["path", { d: "M19 9C20.1046 9 21 9.89543 21 11V19C21 20.1046 20.1046 21 19 21H11C9.89543 21 9 20.1046 9 19V16C9 15.4477 9.44772 15 10 15H14C14.5523 15 15 14.5523 15 14V13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 11L9 10C9 9.44772 9.44772 9 10 9L14 9C14.5523 9 15 8.55229 15 8L15 5C15 3.89543 14.1046 3 13 3L5 3C3.89543 3 3 3.89543 3 5L3 13C3 14.1046 3.89543 15 5 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default SquaresExcludeIcon;
